var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProcessPreview',{attrs:{"processID":_vm.processID,"version":_vm.version,"params":_vm.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }